<template>
  <AdaptiveImage
    v-if="hasBackgroundImage"
    :class="rootClass"
    :style="rootStyle"
    :id="rendering?.dataSource"
    :field="fields?.backgroundImage"
  >
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div class="text-and-icon-section-content">
        <div class="text-and-icon-section-content-container">
          <div class="text-and-icon-section-content-text">
            <JssRichText :field="fields?.title" tag="h2" />
            <JssRichText class="text-and-icon-section-content-text--desc" :field="fields?.text" />
          </div>
          <AdaptiveImage
            class="text-and-icon-section-content-image"
            :field="fields?.image"
            :isBackground="false"
            :lazy-load="false"
            :enableScrollDetection="false"
            :show="true"
          />
        </div>
      </div>
    </ContentGrid>
  </AdaptiveImage>
  <div v-else :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div class="text-and-icon-section-content">
        <div class="text-and-icon-section-content-container">
          <div class="text-and-icon-section-content-text">
            <JssRichText :field="fields?.title" tag="h2" />
            <JssRichText class="text-and-icon-section-content-text--desc" :field="fields?.text" />
          </div>
          <AdaptiveImage
            class="text-and-icon-section-content-image"
            :field="fields?.image"
            :isBackground="false"
            :lazy-load="false"
            :enableScrollDetection="false"
            :show="true"
          />
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';
import useDevice from '@/hooks/useDevice';

export default {
  name: 'TextAndIconSection',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const { deviceComputes } = useDevice();

    const rootClass = computed(() =>
      utils.overall.baseComClass(props.fields, 'text-and-icon-section', {
        reserve: props.fields?.reserve?.value,
      })
    );

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return { ...result };
    });

    const hasBackgroundImage = computed(() => !!props.fields?.backgroundImage?.fields);

    return {
      rootClass,
      rootStyle,
      hasBackgroundImage,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.text-and-icon-section {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-content {
    width: 100%;
    &-bg {
      width: 100%;
      height: auto;
    }

    &-container {
      width: 100%;
      min-height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    &-text {
      font-size: 16px;
      line-height: 24px;
      color: $grey-black;
      width: 100%;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      gap: 20px;

      &-title {
        font-size: 24px;
        font-weight: bold;
        line-height: 1.2;
        color: $grey-black;
      }
    }

    &-image {
      width: 100%;
      height: auto;
    }
  }

  &.reserve {
    &-content {
      &-container {
        flex-direction: column-reverse;
      }

      &-text {
        margin-bottom: 0;
        margin-top: 20px;
      }

      &-image {
        order: 2;
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;
    &-content {
      &-container {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      &-text {
        width: grid-width(14);
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 0;
        margin-top: 0;
        order: 1;
        gap: 24px;

        &-title {
          font-size: 32px;
        }
      }

      &-image {
        width: grid-width(8);
        order: 2;
      }
    }

    &.reserve {
      .text-and-icon-section-content-text {
        order: 3;
      }

      &-image {
        order: 1;
      }
    }
  }
}
</style>
